export default __webpack_public_path__ + "static/media/Layout_Compensation_Incentive_Program.4eca65c1.xlsx";